import { STATUS_FINISHED } from 'services/constants';
import { translate } from 'react-i18next';

// Services
import { getAppointmentViewState } from 'src/services/functions';

// Styles
import { TriggerButton } from './styles';

const buttonTitles = {
  patient_arrive: 'register_arrival_button',
  consultation_start: 'start',
  radiology_finish: 'done',
  radiology_finish_during_consultation: 'done',
  radiology_start: 'radiology',
  radiology_start_during_consultation: 'radiology',
  consultation_restart: 'restart_consultation',
  consultation_start_after_radiology: 'start_consultation_button',
  consultation_finish: 'finish',
  consultation_pay: 'confirm_pay_appointment_details',
  consultation_review: 'read_feedback'
};

export default translate()(props => {
  const {
    activeAppointment: { invoice, appointment },
    handlerButton,
    disabled,
    i18n,
    trigger
  } = props;
  const isDisabled =
    (STATUS_FINISHED === getAppointmentViewState(appointment) && !invoice) || disabled;

  return (
    <TriggerButton
      className={trigger}
      key={trigger}
      onClick={() => handlerButton(trigger)}
      disabled={isDisabled}
    >
      {i18n.t(buttonTitles[trigger])}
    </TriggerButton>
  );
});
